
import {useContext} from "react";
import {LANGUAGE} from "../common/i18n/locales/localeConstant";
import {LocaleContext} from "../store/providers/LocaleProvider";

export const useHelpSection = () => {
    const {locale, localeUppercaseUnderscore} = useContext(LocaleContext)[0];

    const getHelpUrl = (specificSection = null, source = null) => {
        let url = "https://help.hapimag.com/s";

        if (specificSection) {
            url += specificSection;
        }

        url += "?language=";
        url += (locale === LANGUAGE.EN || locale === LANGUAGE.NL) ? localeUppercaseUnderscore : locale.split("-")[0];

        if(source) {
            url += `&source=${source}`;
        }

        return url;
    };

    return {
        getHelpUrl
    };
};
